import { passwordString, requiredString } from 'src/utils/schemas';
import * as Yup from 'yup';

export const confirmResetPasswordValidationSchema = Yup.object().shape({
	code: requiredString.length(6, 'Verification code must be 6 characters length'),
	password: passwordString,
});
